import { getQueryString, removeQueryParams, getCurrentPath } from '@framework/router';

export interface IBuildFilterUrlOptions {
  query: Record<string, string | string[]>,
  asPath: string,
  filterKey: string,
  filterValue: string,
  paramsToRemove?: string[],
}

export const buildFilterUrl = ({
  query,
  asPath,
  filterKey,
  filterValue,
  paramsToRemove = [],
}: IBuildFilterUrlOptions): string => {
  const cleanedQuery = paramsToRemove.length > 0
    ? removeQueryParams(query, paramsToRemove)
    : query;

  const newQuery = {
    ...cleanedQuery,
    [filterKey]: filterValue,
  };

  const searchQuery = getQueryString(newQuery);
  return `${ getCurrentPath(asPath) }?${ searchQuery }`;
};

export const extractSearchQuery = (url: string): string => {
  const parts = url.split('?');
  return parts.length > 1 ? parts[1] : '';
};
